import React from 'react';
import AutocompleteTextInput from '../../common/AutocompleteTextInput';

export default class FieldSingleSearchDropdown extends React.Component {
    state = {
        value: ''
    }

    componentDidMount() {
        const selectedOption = this.getSelectedOptionByValue(this.props.field.value);
        if (selectedOption) {
            this.setState({
                value: selectedOption.text
            })
        }
    }

    render() {
        const options = this.getOptions();

        return (
            <React.Fragment>
                <AutocompleteTextInput
                    placeholder={__('Find')}
                    value={this.state.value}
                    options={options}
                    onChange={value => this.onChange(value)}
                    onOptionClick={option => this.onOptionClick(option)}/>
            </React.Fragment>
        )
    }

    onChange = value => {
        let newValue = value;
        if (typeof value !== 'string') {
            newValue = value.text;
        }

        this.setState({
            value: newValue
        }, () => {
            this.props.onOptionClick(0)
        })
    }

    onOptionClick = option => {
        this.setState({
            value: option.text
        }, () => {
            this.props.onOptionClick(option.value);
        })
    }

    getOptions = () => {
        let items = this.state.value ? this.props.field.items.filter(x => this.state.value && x.text.toLowerCase().includes(this.state.value.toLowerCase())) : this.props.field.items;
        if (items.length === 1 && items[0].text === this.state.value) {
            return [];
        }

        return items;
    }

    getSelectedOptionByValue = value => this.props.field.items.find(x => x.value === value);
}